import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DatepickerOptions } from 'ng2-datepicker';
import { CommercialDetailsItemsComponent } from '../commercial-details-items/commercial-details-items.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'generate-commercial-invoice',
  templateUrl: './generate-commercial-invoice.component.html',
  styleUrls: ['./generate-commercial-invoice.component.scss']
})
export class GenerateCommercialInvoiceComponent implements OnInit {

  constructor(private translate: TranslateService) { }

  @Input() lock = false;
  @Output() close = new EventEmitter();
  @Input() receiptData;
  @Input() generateInvoiceData;
  @Output() onGenerateInvoiceClick = new EventEmitter();

  requiredText = "Required";
  options: DatepickerOptions = {
    calendarClass: 'datepicker-blue',
    scrollBarColor: '#ffffff'
  };
  
  @ViewChild('commercialInvoice') commercialDetailsItemsComponent: CommercialDetailsItemsComponent;

  invoiceNumber: string = '';
  taxId: string = '';
  invoiceDate: Date;
  reasonForExport: string = '';
  invoiceItems = [];
  errors = [];

  closeRecepit() {
    this.close.emit(true);
  }

  checkError(key = 'ALL') {
    const isAll = key == 'ALL';
    if (key == 'invoiceNumber' || isAll) {
      if (typeof this.invoiceNumber == 'string' && this.invoiceNumber.trim() == '') {
        this.updateError(true, 'invoiceNumber', this.requiredText);
      } else {
        this.updateError(false, 'invoiceNumber');
      }
    }

    if (key == 'taxId' || isAll) {
      if (typeof this.taxId == 'string' && this.taxId.trim() == '') {
        this.updateError(true, 'taxId', this.requiredText);
      } else {
        this.updateError(false, 'taxId');
      }
    }

    if (key == 'invoiceDate' || isAll) {
      if (this.invoiceDate == undefined || this.invoiceDate == null) {
        this.updateError(true, 'invoiceDate', this.requiredText);
      } else {
        this.updateError(false, 'invoiceDate');
      }
    }
    
    if (key == 'reasonForExport' || isAll) {
      if (typeof this.reasonForExport == 'string' && this.reasonForExport.trim() == '') {
        this.updateError(true, 'reasonForExport', this.requiredText);
      } else {
        this.updateError(false, 'reasonForExport');
      }
    }
  }

  getError(key) {
    return this.errors.find(i => i.key == key)?.message || null;
  }

  updateError(isAdd, key, message = '') {
    this.errors = this.errors.filter(i => i.key != key);

    if (isAdd) {
      this.errors.push({
        key,
        message
      })
    }
  }

  onSaveClick() {
    this.checkError();

    if (this.errors.length == 0)
      this.addCommercialInvoice();
  }

  addCommercialInvoice() {
    this.onGenerateInvoiceClick.emit({
      invoiceNumber: this.invoiceNumber,
      taxId: this.taxId,
      invoiceDate: this.invoiceDate,
      reasonForExport: this.reasonForExport,
      invoiceItems: this.commercialDetailsItemsComponent.shipmentItems
    });
    this.closeRecepit();
  }

  ngOnInit() {
    if (this.generateInvoiceData != null && this.generateInvoiceData != undefined && Object.keys(this.generateInvoiceData).length > 0) {
      this.invoiceNumber = this.generateInvoiceData?.invoiceNumber;
      this.taxId = this.generateInvoiceData?.taxId;
      this.invoiceDate = this.generateInvoiceData?.invoiceDate;
      this.reasonForExport = this.generateInvoiceData?.reasonForExport;
    }
    this.requiredText = this.translate.instant('common.required')
  }

}
